import { ExclamationCircleIcon } from '@heroicons/react/outline';
import { PlacesType } from 'react-tooltip';
import classNames from 'classnames';
import Tooltip from './tooltips/Tooltip';

const InformationTip = ({ tooltipContent, className, place = 'right-end' }: { tooltipContent: string; className?: string; place?: PlacesType }) => {
  if (!tooltipContent) return null;

  return (
    <Tooltip tooltipContent={tooltipContent} className='z-[100] bg-gray-300 text-black-100 rounded-md min-w-[200px]' place={place}>
      <ExclamationCircleIcon className={classNames('h-6 w-6 text-gray-600 rotate-180', className)} />
    </Tooltip>
  );
};

export default InformationTip;
